import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=24188cd4&scoped=true&"
import script from "./Journal.vue?vue&type=script&lang=js&"
export * from "./Journal.vue?vue&type=script&lang=js&"
import style0 from "./Journal.vue?vue&type=style&index=0&id=24188cd4&lang=less&scoped=true&"
import style1 from "./Journal.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24188cd4",
  null
  
)

export default component.exports